export default <svg xmlns="http://www.w3.org/2000/svg" width="42" height="43" viewBox="0 0 42 43">
  <g id="arrow" transform="translate(-0.494 0)">
    <rect id="Rectangle_18" data-name="Rectangle 18" width="42" height="43" transform="translate(0.494 0)" fill="none"/>
    <line id="Line_6" data-name="Line 6" x2="29" transform="translate(6.494 21)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    <path id="Path_10" data-name="Path 10" d="M40,56,52.023,68.023,40,80.045" transform="translate(-15.955 -46.649)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
  </g>
</svg>
